
import { useWebPageForm } from "@/contexts/WebPageFormContext";
import AboutAFSA from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/AboutAFSA";
import MissionStatement from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/MissionStatement";
import MemberCountries1 from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/MemberCountries1";
import HistoricalTimeline from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/HistoricalTimeline";
import LegalFoundation from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/LegalFoundation";
import Leadership from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/Leadership";
import MemberCountries2 from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/MemberCountries2";
import JoinNewsletter from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/JoinNewsletter";
import HeroSection from "@/components/admin/Content/WebPages/AboutUs/WhoWeAre/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";



const WhoWeAre = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 2xl:w-4/5 mx-auto">
      <HeroSection data={pageData?.WHO_ARE_WE_BANNER ?? {
        sectionTag: 'WHO_ARE_WE_BANNER',
        contentType: 'WITH_FILE',
        title: 'Who We Are Banner',
        description: 'Banner for the Who We Are page'
      }} />

      <div className="grid gap-4 lg:gap-8 lg:grid-cols-[60%_1fr] ">
        <AboutAFSA data={pageData?.WHO_ARE_WE_ABOUT_AFRICA_SPACE_AGENCY ?? {
          sectionTag: 'WHO_ARE_WE_ABOUT_AFRICA_SPACE_AGENCY',
          contentType: 'WITHOUT_FILE',
          sectionTitle: 'About Africa Space Agency',
          title: 'About AFSA'
        }} />
        <MissionStatement data={pageData?.WHO_ARE_WE_MISSION_STATEMENT ?? {
          sectionTag: 'WHO_ARE_WE_MISSION_STATEMENT',
          contentType: 'WITHOUT_FILE',
          sectionTitle: 'Mission Statement',
          title: 'Mission & Vision'
        }} />
      </div>

      <MemberCountries1 data={pageData?.WHO_ARE_WE_MEMBER_COUNTRIES ?? {
        sectionTag: 'WHO_ARE_WE_MEMBER_COUNTRIES',
        contentType: 'WITHOUT_FILE',
        sectionTitle: 'Member Countries',
        title: 'Our Member Countries'
      }} />

      <div className="grid gap-4 lg:gap-6 md:grid-cols-2">
        <HistoricalTimeline data={pageData?.WHO_ARE_WE_HISTORICAL_TIMELINE ?? {
          sectionTag: 'WHO_ARE_WE_HISTORICAL_TIMELINE',
          contentType: 'WITHOUT_FILE',
          sectionTitle: 'Historical Timeline',
          title: 'Our History'
        }} />
        <LegalFoundation data={pageData?.WHO_ARE_WE_LEGAL_FOUNDATION ?? {
          sectionTag: 'WHO_ARE_WE_LEGAL_FOUNDATION',
          contentType: 'WITHOUT_FILE',
          sectionTitle: 'Legal Foundation',
          title: 'Legal Basis'
        }} />
        <Leadership data={pageData?.WHO_ARE_WE_LEADERSHIP ?? {
          sectionTag: 'WHO_ARE_WE_LEADERSHIP',
          contentType: 'WITHOUT_FILE',
          sectionTitle: 'Leadership',
          title: 'Our Leadership'
        }} />
        <MemberCountries2 data={pageData?.WHO_ARE_WE_MEMBER_COUNTRIES_2 ?? {
          sectionTag: 'WHO_ARE_WE_MEMBER_COUNTRIES_2',
          contentType: 'WITHOUT_FILE',
          sectionTitle: 'Member Countries (Secondary)',
          title: 'African Space Policy'
        }} />
      </div>

      <JoinNewsletter data={pageData?.WHO_ARE_WE_JOIN_OUR_NEWSLETTER ?? {
        sectionTag: 'WHO_ARE_WE_JOIN_OUR_NEWSLETTER',
        contentType: 'WITHOUT_FILE',
        sectionTitle: 'Join Our Newsletter',
        title: 'Stay Informed'
      }} />
    </div>
  )
}

export default WhoWeAre